module.exports = __webpack_public_path__ + "b0c6ae2de47b45f22451717165df8424.svg";